import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { TemplateSelection } from '../agent-conversation.model';
import { TemplateCard } from '../agent-template-cards';

// Renders template cards as an interactive picker. Clicking one emits a selection the store turns
// into a model-driven create-from-template turn; nothing here mutates.
@Component({
  selector: 'app-agent-template-picker',
  templateUrl: './agent-template-picker.component.html',
  styleUrls: ['./agent-template-picker.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AgentTemplatePickerComponent {
  readonly cards = input.required<TemplateCard[]>();
  // False once the turn is no longer the live one: greys out and stops emitting so a stale click
  // can't create.
  readonly active = input<boolean>(true);
  readonly pick = output<TemplateSelection>();

  protected choose(card: TemplateCard): void {
    if (!this.active()) {
      return;
    }
    this.pick.emit({ templateId: card.templateId, name: card.name });
  }
}
